module.exports = __webpack_public_path__ + "static/media/IMA.9a239f79.jpg";